// extracted by mini-css-extract-plugin
module.exports = {"wholeFacilityBtn":"HouseInfoForm_wholeFacilityBtn__3WcNl"};